import { userConstants } from "../_constants";
import { userService } from "../_services";
let user = JSON.parse(sessionStorage.getItem("user"));
const initialState = user ? { loggingIn: false, loggedIn: true, user, error: false, token: null, 
    deviceTokenId: null,
    claims: null, userId: null, userName: null, currentAction: userService.ACTION_LOGIN } : {};

export function authentication(state = initialState, action) {
    
    switch (action.type) {
        
        case userConstants.LOGIN_REQUEST:
            return {
                loggingIn: true,
                loggedIn: false,
                error: false,
                user: action.user,
                token: null,
                deviceTokenId: null, 
                claims: null,
                userId: null,
                userName: null,
                currentAction : userService.ACTION_LOGIN
            };
        case userConstants.LOGIN_DEVICE_AUTH_REQUIRED:
            return {
                loggingIn: false,
                loggedIn: false,
                error: false,
                user: action.user,
                token: null,
                claims: null,
                userId: null,
                userName: null,
                currentAction : userService.ACTION_AUTH_DEVICE
            };
        case userConstants.LOGIN_SUCCESS:
            return {
                loggingIn: false,
                loggedIn: true,
                error: false,
                user: action.user,
                token: action.user.data.tokenString,
                claims: action.user.data.claims,
                userId: action.user.data.user.userId,
                userName: action.user.data.user.userName, 
                currentAction: state.currentAction
            };
        case userConstants.LOGIN_FAILURE:
            return {
                loggingIn: false,
                loggedIn: false,
                error: true,
                user: null,
                token: null,
                claims: null,
                userId: null,
                userName: null , 
                currentAction: state.currentAction
            };
            case userConstants.LOGIN_DEVICE_AUTH_FAILURE:
                return {
                    loggingIn: false,
                    loggedIn: false,
                    error: true,
                    user: null,
                    token: null,
                    claims: null,
                    userId: null,
                    userName: null , 
                    deviceTokenId: action.deviceTokenId,
                    currentAction: userService.ACTION_AUTH_DEVICE_CODE
                };
            
        case userConstants.LOGOUT:
            return {
                loggingIn: false, loggedIn: false, error: false, user: null,
                token: null,
                claims: null,
                userId: null,
                userName: null, 
                currentAction: userService.ACTION_LOGIN};
        case userConstants.LOGIN_SEND_DEVICE_AUTH_CODE:
            return{
                deviceTokenId: action.deviceTokenId,
                currentAction: userService.ACTION_AUTH_DEVICE_CODE
            }
        case userConstants.EMAIL_IN_USE:
            return {
                loggingIn: false, loggedIn: false, error: true, user: null,
                token: null,
                claims: null,
                userId: null,
                userName: null,
                currentAction: userService.ACTION_SHOW_EMAIL_IN_USE
            };
        case userConstants.USER_HASH_IN_USE:
            return {
                loggingIn: false, loggedIn: false, error: true, user: null,
                token: null,
                claims: null,
                userId: null,
                userName: null,
                currentAction: userService.ACTION_USER_HASH_IN_USE
            }; 
        case userConstants.RECAPTCHA_FAILED:
            return {
                loggingIn: false, loggedIn: false, error: true, user: null,
                token: null,
                claims: null,
                userId: null,
                userName: null,
                currentAction: userService.ACTION_SHOW_RECAPTCHA_FAILED
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/_reducers/authentication.reducer.js